import React, { useState } from 'react'
import Slides from '../slides/Slides';
import { Link } from 'react-router-dom';
import axios from 'axios';

const  PagoPoliza = ({M}) => {
   const [cuotas,setCuotas]                = useState();
   const [nroPoliza, setNroPoliza]         = useState("");
   const [calcularCuota, setCalcularCuota] = useState(false);
   const [resultado,setResultado]          = useState([]);

   const handleSubmitCalcularCuotas = (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);

      axios
      .post(`${process.env.REACT_APP_API_URL}/web/calcularCuotas`,formData)
      .then((payload) => {
         //setCuotas(payload.data);
         setResultado(payload.data.data);
         setCalcularCuota(payload.data.data.calcularCuota)
         

      })
      .catch((error) => {});
   }
   const handleGetCuotas = () => {
      axios
      .get(`${process.env.REACT_APP_API_URL}/web/getCuotasPoliza/${nroPoliza}`)
      .then((payload) => {
         setCuotas(payload.data);
      })
      .catch((error) => {});
   }
   const handleSubmitMacroClick = (e) => {
      e.preventDefault();
      const form = e.target;
      const formData = new FormData(form);

      axios
      .post(`${resultado?.url}`,formData)
      .then((payload) => {
         //setCuotas(payload.data);
         setResultado(payload.data.data);
         setCalcularCuota(payload.data.data.calcularCuota)
         

      })
      .catch((error) => {});
   }
   console.log(resultado?.url);
   return (
      <>
         <Slides M={M} tipoSlides={"pagoPoliza"}></Slides>
         <div className="section animated fadeIn">
            <div className="row center">
               <h5 className="light-blue-text text-accent-3">PÁGO DE PÓLIZA DEL AUTOMOTOR</h5>
                  <div className="container">
                     <div className="row center">
                        <div className="input-field col s12 m5 l5 xl5">
                           <input type="number" value={nroPoliza} onChange={(e) => setNroPoliza(e.target.value)}/>
                           <label htmlFor="polizaNumero" disabled="">Número de Póliza</label>
                        </div>
                        <div className="input-field col s12 m1 l1 x1">
                           <Link type="button" className="btn-floating waves-effect waves-light light-blue accent-3" onClick={()=>handleGetCuotas()}><i className="material-icons left">search</i></Link>
                        </div>
                        <div className="input-field col s12 m1 l1 x1">
                           <Link type="button" className="btn waves-effect waves-orange purple darken-4 modal-trigger pulse" href="#modalInstructivoPoliza">Instructivo</Link>
                        </div>
                     </div>
                        {!calcularCuota ?                       
                           <>
                              <form onSubmit={(e)=>handleSubmitCalcularCuotas(e)}>
                                 <div className="table-responsive height-table-scroll">
                                    <table className="centered striped responsive-table">
                                       <thead>
                                          <tr>
                                             <th scope="col"><label><input type="checkbox" className="check" id="checkAll"/><span></span></label></th>
                                             <th scope="col">CUIT</th>
                                             <th scope="col">APELLIDO Y NOMBRE</th>
                                             <th scope="col">PÓLIZA</th>
                                             <th scope="col">CUOTA</th>
                                             <th scope="col">FECHA VENCIMIENTO</th>
                                             <th scope="col">IMPORTE</th>
                                             <th scope="col">ESTADO</th>
                                          </tr>
                                       </thead>
                                       <tbody className="center">
                                          {
                                             cuotas?.map((c,index) => {
                                                return (
                                                   <tr key={index}>
                                                      <td><label><input type="checkbox" className="check" name={`poliza[${c.poliza_id}]`}/><span></span></label></td>
                                                      <td>{c.poliza_cuit}</td>
                                                      <td>{c.poliza_apellido_nombre}</td>
                                                      <td>{c.poliza_numero}</td>
                                                      <td>{c.poliza_cuota}</td>
                                                      <td>{c.poliza_vto}</td>
                                                      <td>${c.poliza_monto}</td>
                                                      <td><i title='No Pagado' class='material-icons red-text'>cancel</i></td>
                                                   </tr>
                                                );
                                             })
                                          }
                                       </tbody>
                                    </table>
                                 </div>
                                 <div className="row mb-3">
                                       <input type="submit" className="btn btn-md btn-latitud" value="CALCULAR CUOTAS"/>
                                 </div>
                              </form>
                           </>
                           :
                           <>
                           <form onSubmit={(e)=>handleSubmitMacroClick(e)}>
                              <div className="table-responsive height-table-scroll">
                                 <table className="centered striped responsive-table">
                                    <thead>
                                       <tr>
                                          <th scope="col">CUIT</th>
                                          <th scope="col">APELLIDO Y NOMBRE</th>
                                          <th scope="col">PÓLIZA</th>
                                          <th scope="col">TOTAL A PAGAR</th>
                                       </tr>
                                    </thead>
                                    <tbody className="center">
                                       <tr>
                                          <td>{resultado?.poliza_cuit}</td>
                                          <td>{resultado?.poliza_apellido_nombre}</td>
                                          <td>{resultado?.poliza_numero}</td>
                                          <td>${resultado?.total}</td>
                                       </tr>
                                    </tbody>  
                                 </table>
                              </div>
                              <input type="hidden" name="CallbackSuccess" id="CallbackSuccess" value={resultado?.callbackEncriptada}/>
                              <input type="hidden" name="CallbackCancel" id="CallbackCancel" value={resultado?.cancelEncriptada}/>
                              <input type="hidden" name="COMERCIO" id="Comercio" value={resultado?.comercio}/>
                              <input type="hidden" name="SucursalComercio" id="Sucursal" value={resultado?.sucursalEncriptada}/>
                              <input type="hidden" name="TransaccionComercioId" value={resultado?.transaccion_numero} id="TransaccionComercioId"/>
                              <input type="hidden" name="Monto" id="Monto" value={resultado?.montoEncriptado}/>
                              <input type="hidden" name="Hash" id="firma" value={resultado?.hashfinal}/>
                              {
                                 resultado?.dataPoliza?.map((d,index) => {
                                    return (
                                       <React.Fragment key={index}>
                                          <input type="hidden" name={`Producto[${index}]`} value={d?.transaccion_item}/>
                                          <input type="hidden" name={`MontoProducto[${index}]`}  value={d?.transaccion_priceitem} />
                                       </React.Fragment>
                                    )
                                 })
                              }
                              <div class="row mb-3">
                                 <input type="submit" class="btn btn-md btn-latitud"  id="macroClickPago" value="MACRO CLICK DE PAGO"/>
                              </div>
                           </form>
                           </>
                        }                        
                  </div>
            </div>
         </div>
      </>
   )
}

export default PagoPoliza;